<script>

import Popper from "vue3-popper";
import { useToast } from "vue-toastification";

import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'


import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getTaskItem, saveTaskItem, createTaskItem, getTaskItemTypeOptions, getTaskItemStatesOptions } from '@/services/working/serviceTask';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'TaskItemEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper,Datepicker
		,LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'taskItemId': String, 'taskId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["taskItemId", "taskId", "changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,

			optionsAccessLevels: [],
			optionsStates:[],
		
			//form
			data:[],
			
			optionsTaskItemTypes: [],
			optionsTaskItemStates: [],
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form

		

		loadDefaultValues:function(){
			
			this.isLoading=true
			
			getTaskItem({taskItemId:this.taskItemId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
			getTaskItemTypeOptions().then(response => {
				if(!response.statusText){
					this.optionsTaskItemTypes = response.optionsTaskItemTypes;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getTaskItemStatesOptions().then(response => {
				if(!response.statusText){
					this.optionsTaskItemStates = response.optionsTaskItemStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});


		},

		onClose:function(){
			this.$emit('changeRecord', '')
			this.modalObject.hide();
		},
		
		
		checkSave:function(){
		
			if(!this.data.title){this.data.titleError = true; }else{this.data.titleError = false;}
			if(!this.data.status){this.data.statusError = true; }else{this.data.statusError = false;}
			if(!this.data.type){this.data.typeError = true; }else{this.data.typeError = false;}

			if(this.data.work_start && this.data.work_end){
				
				var timeStart = new Date(this.data.work_start);
			
				var timeEnd = new Date(this.data.work_end);
			
				var diffMs = (timeEnd - timeStart); // milliseconds between 
				
				var minutes = Math.floor(diffMs / 60000);
			
				if(minutes>0){
					this.data.timeIsDisabled = true;
					this.data.work_time = minutes;
				}else{
					this.data.timeIsDisabled = false;
					
				}
				
			}else{
				this.data.timeIsDisabled = false;
				
			}
			
			if(!this.data.titleError && !this.data.statusError && !this.data.typeError){
				return true;
			}else{
				return false;
			}
			
		},

		onSave:function(){
			
			if(this.checkSave()){
				if(this.taskItemId!='null'){	
					this.isSending=true
					saveTaskItem({taskId:this.taskId,data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createTaskItem({taskId:this.taskId,data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			}
			
		}

		
	},
	
	watch: {
		taskItemId() {
			this.loadDefaultValues();
		},
		'data.work_start'() {
			this.checkSave();
		},
		'data.work_end'() {
			this.checkSave();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg modal-dialog-scrollable">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomWorking.TaskItem') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.tasksEdit || auth.tasksNew)" class="modal-body">
											
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':task.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+v.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>

									<div class="form-row">
										
										<div class="form-group col-md-2 col-3">
											<label><b>{{ $t('msgCore.ID') }}</b></label><br>
											{{data.id}}
										</div>
										
										
										<div class="form-group col-md-10 col-12">
											<label :class="{'text-danger':data.titleError}"><b>{{ $t('msgCore.title') }}</b> </label>
											<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.titleError}" v-model="data.title" v-on:change="checkSave()" >
											<div v-show="data.titleError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
										</div>
										
										<div class="form-group col-md-12 col-12">
											<label><b>{{ $t('msgCore.description') }}</b> </label>
											<input type="text" class="form-control form-control-sm"  v-model="data.description" >
										</div>
									</div>

									
									<div class="form-row">
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCustomWorking.WorkStart') }}</b> </label>
										
											<Datepicker v-model="data.work_start" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')" @input="checkSave()"  ></Datepicker>
										</div>
										
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCustomWorking.WorkEnd') }}</b> </label>
											
											<Datepicker v-model="data.work_end" format="yyyy-MM-dd HH:mm" :locale="$i18n.locale"  :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')"  @update="checkSave()" ></Datepicker>
										</div>
									</div>	
										
									<div class="form-row">	
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCore.Time') }} [min]</b> </label>
											<input type="text" class="form-control form-control-sm" :disabled="data.timeIsDisabled" v-model="data.work_time" >
										</div>
										
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCore.Price') }} [€/hod]</b> </label>
											<input type="text" class="form-control form-control-sm"  v-model="data.price" >
										</div>
									
																					
										<div class="form-group col-md-6 col-12">
											<label :class="{'text-danger':data.typeError}"><b>{{ $t('msgCore.Type') }}</b></label>
																								
											<select v-model='data.type' class="form-control form-control-sm " :class="{'is-invalid':data.typeError}"  v-on:change="checkSave()" >
												<option  value="">{{ $t('msgCore.selectType') }}</option>
												<option v-for="(option ) in optionsTaskItemTypes" :key="option" :value="option.value">{{ $t('msgCustomWorking.'+option.title) }}</option>
											</select>
											<div v-show="data.typeError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectType')}}</span></div>
										</div>
										
										<div class="form-group col-md-6 col-12">
											<label :class="{'text-danger':data.statusError}"><b>{{ $t('msgCore.Status') }}</b></label>
																								
											<select v-model='data.status' class="form-control form-control-sm " :class="{'is-invalid':data.statusError}"   v-on:change="checkSave()" >
												<option  value="">{{ $t('msgCore.selectStatus') }}</option>
												<option v-for="(option) in optionsTaskItemStates" :key="option" :value="option.value">{{ $t('msgCustomWorking.'+option.title) }}</option>
											</select>
											<div v-show="data.statusError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectStatus')}}</span></div>
										</div>
										
									</div>	
								
									
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							
							
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="((!auth.tasksEdit) || (!auth.tasksNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		
	</div>
	
	

</template>


